<template>
  <NonScDrawer :open="drawer.open" @closed="() => (drawer.open = false)">
    <template slot="body">
      <div class="drawer-body">
        <div class="editor-header">
          <h4 v-if="title" class="editor-title">
            {{ title }}
          </h4>
        </div>

        <div class="editor-form">
          <div v-if="!isImportHome">
            <p>
              <b>ข้อมูลลูกบ้าน</b>
            </p>
            <div class="form grid-2">
              <div>
                <label>
                  <i
                    v-if="valid.firstName"
                    class="el-icon-circle-check valid"
                  />
                  <i v-else class="el-icon-warning invalid" /> ชื่อจริง
                </label>
                <input
                  v-model="input.firstName"
                  :placeholder="'ระบุชื่อจริง'"
                  type="text"
                  name="firstName"
                  class="input el-input__inner"
                />
              </div>
              <div>
                <label>
                  <i v-if="valid.lastName" class="el-icon-circle-check valid" />
                  <i v-else class="el-icon-warning invalid" /> นามสกุล
                </label>
                <input
                  v-model="input.lastName"
                  :placeholder="'ระบุนามสกุล'"
                  type="text"
                  name="lastName"
                  class="input el-input__inner"
                />
              </div>
            </div>
            <div class="form grid-2">
              <div>
                <label>
                  <i v-if="valid.mobileNo" class="el-icon-circle-check valid" />
                  <i v-else class="el-icon-warning invalid" /> เบอร์มือถือ
                </label>
                <input
                  v-model="input.mobileNo"
                  :placeholder="'ระบุเบอร์มือถือ'"
                  type="text"
                  name="mobileNo"
                  class="input el-input__inner"
                />
                <p class="hint subtitle">
                  เบอร์มือถือต่างประเทศต้องขึ้นต้นด้วย +
                </p>
              </div>
              <div>
                <label>
                  <i
                    v-if="input.email && valid.email"
                    class="el-icon-circle-check valid"
                  />
                  <i v-else-if="input.email" class="el-icon-warning invalid" />
                  อีเมล์
                </label>
                <input
                  v-model="input.email"
                  :placeholder="'ระบุอีเมล์'"
                  type="text"
                  name="email"
                  class="input el-input__inner"
                />
              </div>
            </div>
            <div>
              <label>
                <i v-if="valid.role" class="el-icon-circle-check valid" />
                <i v-else class="el-icon-warning invalid" /> สถานะ
              </label>
              <br />
              <div class="group">
                <el-button
                  v-for="(option, i) in role"
                  :key="i"
                  :type="'sc-asset'"
                  :inactive="input.role != option.value"
                  @click="() => (input.role = option.value)"
                >
                  {{ option.name }}
                </el-button>
              </div>
            </div>
          </div>

          <hr style="margin: var(--size-xs) 0" />

          <p>
            <b>ข้อมูลที่อยู่</b>
          </p>

          <div>
            <label>
              <i v-if="valid.structure" class="el-icon-circle-check valid" />
              <i v-else class="el-icon-warning invalid" /> ประเภทสิ่งก่อสร้าง
            </label>
            <br />
            <div class="group">
              <el-button
                v-for="(option, i) in construct"
                :key="i"
                :type="'sc-asset'"
                :inactive="input.structure != option.name"
                @click="() => (input.structure = option.name)"
              >
                {{ option.name }}
              </el-button>
            </div>
          </div>

          <div class="form grid-2">
            <div>
              <label>
                <i v-if="valid.addressNo" class="el-icon-circle-check valid" />
                <i v-else class="el-icon-warning invalid" /> เลขที่
              </label>
              <input
                v-model="input.addressNo"
                :placeholder="'ระบุเลขที่อยู่ 99, 1/99, หรือ 1/9-9'"
                type="text"
                name="addressNo"
                class="input el-input__inner"
              />
            </div>

            <div>
              <label> ถนน </label>
              <input
                v-model="input.addressRoad"
                :placeholder="'ระบุถนน'"
                type="text"
                name="addressRoad"
                class="input el-input__inner"
              />
            </div>
          </div>

          <div class="form grid-2">
            <div>
              <label> พื้นที่ใช้สอย (ตร.ม.) </label>
              <input
                v-model="input.area"
                :placeholder="'ระบุตัวเลข 1 - 2000 (ตร.ม.)'"
                type="number"
                name="area"
                class="input el-input__inner"
              />
            </div>
            <div>
              <label>
                <i
                  v-if="valid.transferDate"
                  class="el-icon-circle-check valid"
                />
                <i v-else class="el-icon-warning invalid" /> วันที่โอน
              </label>
              <input
                v-model="input.transferDate"
                type="date"
                name="transferDate"
                class="input el-input__inner"
              />
            </div>
          </div>

          <div>
            <label>
              <i v-if="valid.address" class="el-icon-circle-check valid" />
              <i v-else class="el-icon-warning invalid" /> รายละเอียดที่อยู่
            </label>
            <NonScAddress
              :selected="input"
              :open="address.open"
              @selected="(value) => setAddress(value)"
            />
          </div>

          <div class="editor-action group">
            <el-button
              :disabled="!allow"
              class="action"
              type="sc-asset"
              @click="() => submit()"
            >
              บันทึก
            </el-button>
            <el-button
              v-if="mode != 'creator'"
              class="action"
              type="danger"
              @click="() => remove()"
            >
              ลบออก
            </el-button>
            <el-button
              class="action"
              type="info"
              @click="() => (drawer.open = false)"
            >
              ยกเลิก
            </el-button>
          </div>
        </div>
      </div>
    </template>
  </NonScDrawer>
</template>

<script lang="js">
// Common
import { NonScCommon as Common } from "../../common/nonsc.common"

import { NonScImportCommon as ImportCommon } from "../../common/nonsc-home-import.common"

// Components
import NonScAddress from "../../components/NonScAddress"
import NonScDrawer from "../../components/NonScDrawer"

// Utils
import { ValidateUtility as Validate } from "../../utils/validate"

import {
  sanitize, isValidNewInput
} from '../../utils/phone'

export default {
  components: {
    NonScAddress,
    NonScDrawer,
  },
  props: {
    title: {
      type: String,
      default: undefined,
    },
    mode: {
      type: String,
      default: undefined,
    },
    open: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      default: () => ImportCommon.item,
    },
    isImportHome: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    // Init Input State
    const input = { ...ImportCommon.item }

    return {
      drawer: {
        open: false,
      },
      address: {
        open: false,
      },
      input,
    }
  },
  computed: {
    construct() {
      return Common.construct
    },
    role() {
      return Common.role
    },
    valid() {
      // Validator
      const valid = {
        email: false,
        firstName: false,
        lastName: false,
        mobileNo: false,
        addressNo: false,
        address: false,
        structure: false,
        role: false,
        transferDate: false,
      }

      // Validate Input
      if (!this.input) return valid

      // Input Props
      const {
        firstName,
        lastName,
        mobileNo,
        addressNo,
        structure,
        email,
        role,
        transferDate,
      } = this.input

      // Validate Role
      valid.role = !!role && Validate.isRole(role)

      // Validate Name
      valid.firstName = !!firstName && Validate.isName(firstName)
      valid.lastName = !!lastName && Validate.isName(lastName)

      // Validate Mobile Number
      valid.mobileNo = !!mobileNo && isValidNewInput(sanitize(mobileNo))

      // Validate Email
      valid.email = email ? Validate.isEmail(email) : true

      // Validate Address Number
      valid.addressNo = Validate.isAddrNo(addressNo)

      // Validate Address
      valid.address = [
        "tumbonPrefix",
        "tumbonName",
        "amphurPrefix",
        "amphurName",
        "provinceName",
        "zipCode",
      ].every((e) => !!this.input[e])

      // Validate Construction type
      valid.structure = this.construct.some((e) => e.name === structure)

      // Validate Transfer Date
      valid.transferDate = !!transferDate && Validate.isDate(transferDate)

      return valid
    },
    allow() {
      if (this.isImportHome) {
        return (
          this.valid.address && this.valid.structure && this.valid.transferDate
        )
      }

      return Object.values(this.valid).every((e) => e)
    },
  },
  watch: {
    open(value) {
      // Validate State
      if (!value) return

      // Set Drawer
      this.drawer.open = value

      // Set Input
      if (value) {
        this.input = { ...this.form }
      } else {
        setTimeout(() => {
          this.input = { ...ImportCommon.item }
        }, 400)
      }
    },
    "drawer.open": function drawerOpenWatcher(open) {
      if (!open) this.$emit("closed")
    },
  },
  mounted() {
    // Set Drawer
    this.drawer.open = this.open

    // Set Input
    this.input = {
      ...ImportCommon.item,
      ...this.form,
    }
  },
  methods: {
    setAddress(input) {
      // Set Location
      const location = Common.setLocation(input)

      // Validate Input
      if (location) {
        Object.assign(this.input, location)
      }
    },
    submit() {
      // Emit Change
      this.$emit("submit", this.input)

      // Set Drawer
      this.drawer.open = false
    },
    remove() {
      // Emit Remove
      this.$emit("remove", this.input.id)

      // Set Drawer
      this.drawer.open = false
    },
  },
}
</script>

<style lang="css" scoped>
.hint {
  margin: 0.35rem 0 0;
  font-size: 0.8rem;
  font-style: italic;
  line-height: 1.4;
}

.drawer-body {
  display: flex;
  flex-direction: column;
  height: 100svh;
}

.editor-form {
  display: flex;
  flex-direction: column;
  gap: var(--size-sm);
  overflow-x: hidden;
  overflow-y: auto;
}

.editor-header {
  padding: var(--size-lg);
}

.editor-form {
  flex: 1;
  padding: var(--size-lg);
  padding-top: 0;
}

.editor-action {
  display: flex;
  margin-top: var(--size-xs);
}

.editor-title {
  margin: 0;
}

.group {
  display: flex;
  gap: var(--size-xs);
  flex-wrap: wrap;
}

.editor-action.group {
  gap: var(--size-md);
}

.el-button.action {
  min-width: 5rem;
}

@media screen and (max-width: 768px) {
  .editor-header {
    padding: var(--size-md);
  }

  .editor-title {
    text-align: right;
  }
}
</style>
